import React, { useState, useEffect, useRef } from 'react';
import BreadcrumbComponent from '../../../components/common/Breadcrumb'
import NationalEmblem from '../../../assets/svg_main/national_emblem.svg';
import '../TemporaryBenificiary.css'
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/common/Button';
import RedInfoIcon from '../../../assets/svg/exclamation.svg'
import BackArrowsvg from '../../../assets/svg/BackArrowIconSvg.svg'
import CommonFormFields from '../../Forms/CommonFormFields';
import { TemporaryBenificryconstant } from '@constants/index';
import endpoints from '@config/endpoints';
import { toast } from 'react-toastify';
import { getData, getDataWithCache, postDataJSON } from '../../../services/CommonApiService'
import { getUserConsentLanguage } from '@services/childApiServices';
import { useSelector } from 'react-redux';
import WomanIcon from "../../../assets/svg_main/Woman.svg";
import ManIcon from "../../../assets/svg_main/Man.svg";
import { useDispatch } from 'react-redux';
import profilePic from '../../../assets/png/default_profile.png';
import { RootState } from '@store/reducers';
import CustomTooltip from '@components/common/CustomTooltip';
import InfoBar from '@components/common/InfoBars';
import { updateForm } from '@store/actions/userManagementAction';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '../../../utils/base64Utils';
import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import BadgesComponent from '@components/common/Badges';
import { setBeneficiaryAuthType, setBeneficiaryData, setBeneficiaryRedgOption, setTxnIdForAbhaAddress } from '@store/actions/beneficiaryAction';
import Auth from '@utils/auth';
import axios from '../../../utils/axiosExt';
import { errorLogger } from '@utils/applicationLogUtils';
import { Modal } from 'react-bootstrap';
import CheckboxComponent from '@components/common/CheckBox';
import { benef_const } from '@constants/beneficiaryConstant';
import dayjs from 'dayjs';
import ButtonModal from '@components/common/Button';
import { subtractDaysFromDate } from '@utils/commonUtils';
import CommonModal from '@pages/UserManagement/CreateNewUser/AlertModal';
import { buttonNames } from '@constants/appConstants';
import Spinner from '@components/common/Spinner';

interface HealthFComponentProps {
  page: string;
  flow: string;

}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  code?: any
}

export interface formStateType {
  [key: string]: objectType
}

interface CreateProps {
  breadcrumbItemName?: any;
}


const TemporaryBenificiary = (props: HealthFComponentProps,) => {
  const storedUserId = localStorage.getItem('userId');
  const userId = storedUserId
  const { page, flow } = props;
  const initialBeneficiaryState = {
    caste: '',
    pgtvClassified: false,
    enrollSMS: false,
  };
  const Files = useSelector((state: RootState) => state.user.file);
  const navigate = useNavigate();
  const beneficiaryStore = useSelector((state: RootState) => state.beneficiary);
  const [ufId, setUfId] = useState<string>('');
  const [urbanRural, setUrbanRural] = useState<string>('');
  const [temproryBenificiaryformdata, setTemproryBenificiaryFormData] = useState<any>(TemporaryBenificryconstant);
  const [temproryBenificiaryFormState, setTemproryBenificiaryFormState] = useState<formStateType>({
    beneificery_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Gender: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Beneficiary_DOB: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Beneficiary_Mobile_Number: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Spouse_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    caste: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',

    },
    Religion: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    other_religion: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Alternate_Phone_Number: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    sms: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },

    Asha_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Health_Provider_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Facility_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    pvtg: {
      isError: false,
      message: '',
      isDisable: false,
      value: null,
    },
    Enroll_for_SMS: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  }
  )
  const [beneficiary, setBeneficiary] = useState(initialBeneficiaryState);
  const [facilityDetails, setFacilityDetails] = useState<any>([]);
  const [genderId, setGenderId] = useState<string>('');
  const inputRef = useRef<any>(null);
  const [imageError, setImageError] = useState('');
  const [imageUrl, setImageUrl] = useState<string>('');
  const [BeneficiaryDate, setBeneficiaryDate] = useState<any>('');
  const [loginId, setLoginId] = useState<string>('');
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const [regId, setRegId] = useState<string>('');
  const [userType, setUserType] = useState<string>('')
  const [userName, setUserName] = useState<string>('')
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [checkedState, setCheckedState] = useState<boolean[]>([]);
  const [consentLanguageData, setConsentLanguageData] = useState<any>([]);
  const isAllChecked = checkedState?.every((checked) => checked);
  const dispatch = useDispatch()
  const [uploadMethod, setUploadMethod] = useState<'local' | 'url' | null>(
    null,
  );
  const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));

  useEffect(() => {
    setTemproryBenificiaryFormData((prevState: any) => {
      return {
        ...prevState,
        ['Gender']: {
          ...prevState['Gender'],
          '#isDisabled': true,
        }
      }
    })

    const fetchData = async () => {
      setUrbanRural(userDetail.urban_rural_name);
      setUserType(userDetail.usertype_name);
      setUserName(userDetail.first_name + ' ' + userDetail.middle_name + ' ' + userDetail.last_name);

      if (userDetail.urban_rural_name === 'urban') {
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Ward']: {
              ...prevState['Ward'],
              '#options': [],
              '#isDisabled': false,
            },
            ['Village']: {
              ...prevState['Village'],
              '#isDisabled': true,
            }
          }
        })
      }
      else {
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Ward']: {
              ...prevState['Ward'],
              '#isDisabled': true,
            },
            ['Village']: {
              ...prevState['Village'],
              '#options': [],
              '#isDisabled': false,
            }
          }
        })
      }
      const staticBenfCreateDetails = await getDataWithCache<any>(`${endpoints.getStaticBenfCreateDetails}`);
      const caste = staticBenfCreateDetails?.data.categoryData.map((key: any) => ({
        value: key.category_name,
        label: key.category_name,
        id: key.category_id,
        code: key.category_code
      }));
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,

          ['caste']: {
            ...prevState['caste'],
            '#options': caste
          }
        }
      })

      const religion = staticBenfCreateDetails?.data.religionData[0].map((key: any) => ({
        value: key.religion_name,
        label: key.religion_name,
        id: key.religion_id,
        code: key.religion_code
      }));
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Religion']: {
            ...prevState['Religion'],
            '#options': religion
          }
        }
      })

      const facility_details_response = await getData<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
      setFacilityDetails(facility_details_response.data[0]);
      const parentFacility = facility_details_response.data[0].find((item: any) => item.is_parent === true);
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['Facility_Name']: {
          ...prevState['Facility_Name'],
          value: parentFacility?.facility_name,
          id: parentFacility?.facility_id
        },
        ['Facility_type']: {
          ...prevState['Facility_type'],
          value: parentFacility?.facility_type_name,
          id: parentFacility?.facility_type_id
        }

      }))
      setTemproryBenificiaryFormData((beneficiary_facilitydetails: { Health_Provider_Name: any, Facility_Name: any, Asha_Name: any, Ward: any, Village: any }) => ({
        ...beneficiary_facilitydetails,
        Facility_Name: {
          ...beneficiary_facilitydetails.Facility_Name,
          '#options': facility_details_response.data[0]?.map((key: any) => ({
            value: key.facility_name,
            label: key.facility_name,
            id: key.facility_id
          }))
        }
      }));

      if (facility_details_response.data[0].length === 1) {
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          ['Facility_Name']: {
            ...prevState['Facility_Name'],
            value: facility_details_response.data[0][0].facility_name,
            id: facility_details_response.data[0][0].facility_id
          },
          ['Facility_type']: {
            ...prevState['Facility_type'],
            value: facility_details_response.data[0][0].facility_type_name,
            id: facility_details_response.data[0][0].facility_type_id
          }
        }))
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Facility_Name']: {
              ...prevState['Facility_Name'],
              '#isDisabled': true
            },
            ['Facility_Type']: {
              ...prevState['Facility_Type'],
              '#isDisabled': true,
            }
          }
        })
      }
      if(userDetail.usertype_name === 'Field Level User'){
        const healthProviderLinked= await getDataWithCache<any>(`${endpoints.getHealthProviderByAsha}/${userId}/${userDetail.facility_id}`);
        const ashaFullName = [userDetail.first_name, userDetail.middle_name, userDetail.last_name]
        .filter(Boolean)
        .join(' ');
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['Asha_Name']: {
          ...prevState['Asha_Name'],
          value: ashaFullName,
          id:userId
        },
      }));
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          ['Health_Provider_Name']: {
            ...prevState['Health_Provider_Name'],
            value: healthProviderLinked?.data[0][0]?.f_name + ' ' + healthProviderLinked?.data[0][0]?.l_name,
            id: healthProviderLinked?.data[0][0]?.get_healthprovider_id
          }
        }))
        setTemproryBenificiaryFormData((beneficiary_facilitydetails: { Asha_Name: any,Health_Provider_Name:any }) => ({
            ...beneficiary_facilitydetails,
            ['Asha_Name']: {
                ...beneficiary_facilitydetails['Asha_Name'],
                '#isDisabled': true,
            },
            ['Health_Provider_Name']:{
              ...beneficiary_facilitydetails['Health_Provider_Name'],
              '#isDisabled': true,
            }
        }));
    }
      const facilityTypes = facility_details_response?.data[0]?.map((key: any) => ({
        value: key.facility_type_name,
        label: key.facility_type_name,
        id: key.facility_type_id
      }));
      const filteredFacilityType = facilityTypes.filter((obj: any, index: any) => {
        return index === facilityTypes.findIndex((o: any) => obj.value === o.value);
      })
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Facility_Type']: {
            ...prevState['Facility_Type'],
            '#options': filteredFacilityType

          }
        }
      })
      if (beneficiaryStore.beneficiaryGender === "Female" || beneficiaryStore.beneficiaryGender === "F") {
        setGenderId(staticBenfCreateDetails?.data?.genderData?.find((g: any) => g.gender_code === '1002')?.gender_id)
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          Gender: {
            ...prevState.Gender,
            value: 'Female',
          },
        }));
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Beneficiary_DOB']: {
              ...prevState['Beneficiary_DOB'],
              '#maxDate': subtractDaysFromDate(dayjs(), benef_const.beneficiaryMinimumAgeForRegistering, 'year'),
            }
          }
        })
      }
      else if (beneficiaryStore.beneficiaryGender === "Male" || beneficiaryStore.beneficiaryGender === "M") {
        setGenderId(staticBenfCreateDetails?.data?.genderData?.find((g: any) => g.gender_code === '1001')?.gender_id)
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          Gender: {
            ...prevState.Gender,
            value: 'Male',
          },
        }));
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Beneficiary_DOB']: {
              ...prevState['Beneficiary_DOB'],
              '#maxDate': subtractDaysFromDate(dayjs(), benef_const.beneficiaryMinimumAgeForRegistering, 'year'),
            }
          }
        })
      }
      setLoginId(staticBenfCreateDetails.data.loginProcessData[3].login_process_id)
      setRegId(staticBenfCreateDetails.data.registrationProcessData[2].reg_process_id)
    }
    fetchData();
  }, [])
  useEffect(() => { }, [ufId]);
  useEffect(() => {

    if (temproryBenificiaryFormState.caste.value !== 'ST') {
      delete temproryBenificiaryformdata.pvtg;
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['pvtg']: {
          ...prevState['pvtg'],
          value: null,
          isError: false,
          message: ''
        },
      }))
    }
    else {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          pvtg: {
            '#type': 'radioButton',
            '#title': 'Is PVTG Classified',
            '#webform_key': 'pvtg',
            '#required': true,
            '#isDisabled': false,
            '#group': 'beneficiaryCreate',
            '#options': ["Yes", "No"]
          }
        }
      })
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['pvtg']: {
          ...prevState['pvtg'],
          value: '',
          isError: false,
          message: ''
        },
      }))
    }
  }, [temproryBenificiaryFormState.caste.value])
  useEffect(() => {
    if (temproryBenificiaryFormState.Religion.value !== 'Others') {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['other_religion']: {
            ...prevState['other_religion'],
            '#isDisabled': true,
            '#required': false,
          }
        }
      })
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['other_religion']: {
          ...prevState['other_religion'],
          value: '',
          isError: false,
          message: ''
        },
      }))
    }
    else {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['other_religion']: {
            ...prevState['other_religion'],
            '#isDisabled': false,
            '#required': true,
          }
        }
      })
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['other_religion']: {
          ...prevState['other_religion'],
          value: '',
          isError: false,
          message: ''
        },
      }))
    }
  }, [temproryBenificiaryFormState.Religion.value])

  const fetchHealthProviderData = async () => {
    const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(temproryBenificiaryFormState.Facility_Name.id)}`);
    const HealthProvider = Health_provider?.data?.map((key: any) => ({
      value: `${key.f_name} ${key.l_name}`,
      label: `${key.f_name} ${key.l_name}`,
      id: key.user_id,
      code: key.user_code,
      ufTaggedId: key.uf_tagged_id
    }));
    setTemproryBenificiaryFormData((prevState: any) => {
      return {
        ...prevState,
        ['Health_Provider_Name']: {
          ...prevState['Health_Provider_Name'],
          '#options': HealthProvider
        }
      }
    })

    if (userType === 'Facility Level User' || Health_provider?.data.length === 1) {
      const healthProviderData = Health_provider?.data.find((item: any) => `${item.f_name} ${item.l_name}` === userName.replace('null', '').replace('  ', ' '));
      if (healthProviderData) {
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          ['Health_Provider_Name']: {
            ...prevState['Health_Provider_Name'],
            value: healthProviderData?.f_name + ' ' + healthProviderData?.l_name,
            id: healthProviderData?.user_id
          }
        }))
        const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData.uf_tagged_id)}`);
        const Ashaname = AshaName?.data.map((key: any) => ({
          value: key.f_name + " " + key.l_name,
          label: key.f_name + " " + key.l_name,
          id: key.mobiliser_id,
          code: key.user_code
        }));
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Asha_Name']: {
              ...prevState['Asha_Name'],
              '#options': Ashaname
            }
          }
        })
      }
    }

    if(userDetail?.user_designation_name === 'ANM') {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Health_Provider_Name']: {
            ...prevState['Health_Provider_Name'],
            '#isDisabled': true,
          }
        }
      })
    }
  }
  const handleUploadClick = (method: 'local' | 'url') => {
    inputRef.current?.click();
    setUploadMethod(method);
  };
  const isValueContainsOnlyDigits = (value: any) => {
    return /^\d*$/.test(value);
  };
  const handleFormChange = (value: any, key: string, id: any, option: any, code: any,) => {

    if (value && key === 'Beneficiary_DOB') {
      const date = new Date(value)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formatedDate = `${year}-${month}-${day}`
      setBeneficiaryDate(formatedDate)

    }
    if (value && key === 'Facility_Name') {
      const facilityDetail = facilityDetails?.find((item: any) => item.facility_name === value);
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        Facility_type: {
          ...prevState.Facility_type,
          value: facilityDetail.facility_type_name,
          isError: false,
          message: '',
          id: facilityDetail.facility_id,
        },
        Health_Provider_Name: {
          ...prevState.Health_Provider_Name,
          value: '',
          id: ''
        },
        Asha_Name: {
          ...prevState.Health_Provider_Name,
          value: '',
          id: ''
        },
        Ward: {
          ...prevState.Ward,
          value: '',
          id: ''
        },
        Village: {
          ...prevState.Village,
          value: '',
          id: ''
        }
      }));
      setTemproryBenificiaryFormData((prevState: any) => ({
        ...prevState,
        ['Health_Provider_Name']: {
          ...prevState['Health_Provider_Name'],
          '#options': []
        },
        ['Asha_Name']: {
          ...prevState['Asha_Name'],
          '#options': []
        },
        ['Ward']: {
          ...prevState['Ward'],
          '#options': []
        },
        ['Village']: {
          ...prevState['Village'],
          '#options': []
        }
      }))
    } else if (!value && key === 'Facility_Name') {
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,

        Health_Provider_Name: {
          ...prevState.Health_Provider_Name,
          value: '',
          id: ''
        },
        Ward: {
          ...prevState.Ward,
          value: '',
          id: ''
        },
        Village: {
          ...prevState.Village,
          value: '',
          id: ''
        },
        Facility_type: {
          ...prevState.Facility_type,
          value: '',
          id: ''
        },
        Asha_Name: {
          ...prevState.Health_Provider_Name,
          value: '',
          id: ''
        }
      }));
      setTemproryBenificiaryFormData((prevState: any) => ({
        ...prevState,
        ['Health_Provider_Name']: {
          ...prevState['Health_Provider_Name'],
          '#options': []
        },
        ['Asha_Name']: {
          ...prevState['Asha_Name'],
          '#options': []
        },
        ['Ward']: {
          ...prevState['Ward'],
          '#options': []
        },
        ['Village']: {
          ...prevState['Village'],
          '#options': []
        }
      }))
      let facility_name_options = facilityDetails?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_id
      }))
      facility_name_options = facility_name_options?.filter((key: { value: any; }) => key.value)
      setTemproryBenificiaryFormData((beneficiary_facilitydetails: { Health_Provider_Name: any, Facility_Name: any }) => ({
        ...beneficiary_facilitydetails,
        Facility_Name: {
          ...beneficiary_facilitydetails.Facility_Name,
          '#options': facility_name_options,
        }
      }));
    } else if (!value && key === 'Facility_type') {
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        Health_Provider_Name: {
          ...prevState.Health_Provider_Name,
          value: '',
          id: ''
        },
        Facility_Name: {
          ...prevState.Facility_Name,
          value: '',
          id: ''
        },
        Asha_Name: {
          ...prevState.Asha_Name,
          value: '',
          id: ''
        },
        Ward: {
          ...prevState.Ward,
          value: '',
          id: ''
        },
        Village: {
          ...prevState.Village,
          value: '',
          id: ''
        }

      }));
      let facility_name_options = facilityDetails?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_id
      }))
      facility_name_options = facility_name_options?.filter((key: { value: any; }) => key.value)


      setTemproryBenificiaryFormData((beneficiary_facilitydetails: { Health_Provider_Name: any, Facility_Name: any, Asha_Name: any, Ward: any, Village: any }) => ({
        ...beneficiary_facilitydetails,
        Facility_Name: {
          ...beneficiary_facilitydetails.Facility_Name,
          '#options': facility_name_options,
        },
        ['Health_Provider_Name']: {
          ...beneficiary_facilitydetails['Health_Provider_Name'],
          '#options': []
        },
        ['Asha_Name']: {
          ...beneficiary_facilitydetails['Asha_Name'],
          '#options': []
        },
        ['Ward']: {
          ...beneficiary_facilitydetails['Ward'],
          '#options': []
        },
        ['Village']: {
          ...beneficiary_facilitydetails['Village'],
          '#options': []
        }
      }));

    } else if (value && key === 'Facility_type') {
      const filteredFacilityDetails: any[] = facilityDetails?.filter((item: any) => item.facility_type_name === value && item.facility_name) || [];
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        Health_Provider_Name: {
          ...prevState.Health_Provider_Name,
          value: '',
          id: ''
        },
        Facility_Name: {
          ...prevState.Facility_Name,
          value: '',
          id: ''
        },
        Ward: {
          ...prevState.Ward,
          value: '',
          id: ''
        },
        Village: {
          ...prevState.Village,
          value: '',
          id: ''
        },
        Asha_Name: {
          ...prevState.Asha_Name,
          value: '',
          id: ''
        }
      }));
      const facility_name_options = filteredFacilityDetails?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_id
      }))
      setTemproryBenificiaryFormData((beneficiary_facilitydetails: { Health_Provider_Name: any, Facility_Name: any, Asha_Name: any, Ward: any, Village: any }) => ({
        ...beneficiary_facilitydetails,
        Facility_Name: {
          ...beneficiary_facilitydetails.Facility_Name,
          '#options': facility_name_options,
        },
        ['Health_Provider_Name']: {
          ...beneficiary_facilitydetails['Health_Provider_Name'],
          '#options': []
        },
        ['Asha_Name']: {
          ...beneficiary_facilitydetails['Asha_Name'],
          '#options': []
        },
        ['Ward']: {
          ...beneficiary_facilitydetails['Ward'],
          '#options': []
        },
        ['Village']: {
          ...beneficiary_facilitydetails['Village'],
          '#options': []
        }
      }));
    }
    else if (value && key === 'Health_Provider_Name') {
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        Asha_Name: {
          ...prevState.Asha_Name,
          value: '',
          id: '',
          isError: false,
          message: '',
        }
      }));
      const ufTaggedId = option.find((item: any) => item.id === id);
      setUfId(ufTaggedId.ufTaggedId)
    }
    else if (!value && key === 'Health_Provider_Name') {
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        Asha_Name: {
          ...prevState.Asha_Name,
          value: '',
          id: '',
          isError: false,
          message: '',
        }
      }));
    }
    if ((key === "Beneficiary_Mobile_Number" || key === 'Alternate_Phone_Number') && (!isValueContainsOnlyDigits(value) || value.length > 10)) {
      return
    }
    setTemproryBenificiaryFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  }
  const fetchAshaData = async () => {

    const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`);
    const Ashaname = AshaName?.data.map((key: any) => ({
      value: key.f_name + " " + key.l_name,
      label: key.f_name + " " + key.l_name,
      id: key.mobiliser_id,
      code: key.user_code
    }));
    setTemproryBenificiaryFormState((prevState: any) => {
      const prevAshaId = prevState.Asha_Name.id;
      const found = Ashaname?.find((a: any) => a.id === prevAshaId);
      return {
        ...prevState,
        Asha_Name: {
          ...prevState.Asha_Name,
          value: found ? found.value : '',
          id: found ? found.id : '',
          isError: false,
          message: '',
        }
      }
    });
  }
  const fetchWardVillageData = async () => {
    const ufIdData = facilityDetails?.find((item: any) => item.facility_name === temproryBenificiaryFormState.Facility_Name.value);
    if (urbanRural === 'urban') {
      const wardData = await getDataWithCache<any>(`${endpoints.getWardByUfId(ufIdData.uf_id)}`);
      const ward_options = wardData?.data[0]?.map((key: any) => ({
        value: key.ward_name + "-" + key.ward_code,
        label: key.ward_name + "-" + key.ward_code,
        id: key.ward_id
      }))
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Ward']: {
            ...prevState['Ward'],
            '#options': ward_options
          },
          ['Village']: {
            ...prevState['Village'],
            '#isDisabled': true,
          }
        }
      })
    }
    else {
      const villageData = await getDataWithCache<any>(`${endpoints.getVillageByUfId(ufIdData.uf_id)}`);
      const village_options = villageData?.data[0].map((key: any) => ({
        value: key.village_name + "-" + key.village_code,
        label: key.village_name + "-" + key.village_code,
        id: key.village_id
      }))
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Village']: {
            ...prevState['Village'],
            '#options': village_options
          },
          ['Ward']: {
            ...prevState['Ward'],
            '#isDisabled': true
          }
        }
      })
    }
  }
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files && event.target.files[0];
    setImageError('');
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (fileSize > 1048576) {
        setImageError('File size must be less than or equal to 1MB');
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
        setImageError('Only JPG, JPEG and PNG images are allowed');
        return;
      }
      setImageUrl(URL.createObjectURL(selectedFile));
      setUploadMethod(null);
      const file = selectedFile;
      const formData = new FormData()
      formData.append('file', selectedFile);
      dispatch(updateForm("file", formData));

    }
  };

  useEffect(() => {
    if (temproryBenificiaryFormState.Facility_Name.value !== '' && temproryBenificiaryFormState.Facility_Name.value !== undefined) {
      fetchHealthProviderData();
      fetchWardVillageData();
    }
  }, [temproryBenificiaryFormState.Facility_Name.value])
  useEffect(() => {
    if (temproryBenificiaryFormState.Health_Provider_Name.value !== '' && temproryBenificiaryFormState.Health_Provider_Name.value !== undefined &&
      ufId !== '' && ufId !== undefined
    ) {
      fetchAshaData();
    }
  }, [ufId])
  const handleSubmit = async () => {
    const isError: boolean[] = [];
    const beneficiaryFormStateError = {
      ...temproryBenificiaryFormState
    };
    let isBeneficiaryFormError = false;
    Object.keys(beneficiaryFormStateError).map((item) => {

      if (item === 'beneificery_name') {
        if (!beneficiaryFormStateError.beneificery_name?.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.beneificery_name.isError = true;
          beneficiaryFormStateError.beneificery_name.message = 'Beneficiary name cannot be kept blank. Enter a valid beneficiary name.';
        }
        else if (!/^[A-Za-z]+(?:[.\s]+[A-Za-z]+)*\.?$/.test(beneficiaryFormStateError.beneificery_name?.value)) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.beneificery_name.isError = true;
          beneficiaryFormStateError.beneificery_name.message = 'Entered beneficiary name is invalid. Only alphabets,spaces and dot(.) are allowed.';
        } else if (beneficiaryFormStateError.beneificery_name?.value.length > 100) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.beneificery_name.isError = true;
          beneficiaryFormStateError.beneificery_name.message = 'Entered beneficiary name length is invalid. Max 100 characters are allowed.';
        }
        else {
          beneficiaryFormStateError.beneificery_name.isError = false;
        }
      }

      if (item === 'Beneficiary_DOB') {
        if (!beneficiaryFormStateError.Beneficiary_DOB?.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Beneficiary_DOB.isError = true;
          beneficiaryFormStateError.Beneficiary_DOB.message = 'Select Beneficiary DOB.';
        } else {
          beneficiaryFormStateError.Beneficiary_DOB.isError = false;
        }
      }
      if (item === 'Alternate_Phone_Number') {
        if (beneficiaryFormStateError.Alternate_Phone_Number.value.length !== 0) {
          if (!/^\d+$/.test(beneficiaryFormStateError.Alternate_Phone_Number.value)) {
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.isError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.message = "Phone number contains invalid characters. Enter a valid phone number.";
          }else if(beneficiaryFormStateError?.Alternate_Phone_Number?.value?.length !== 10){
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.isError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.message = "Mobile number must contain 10 digits. Enter a valid mobile number.";
          }
        }
        else {
          beneficiaryFormStateError.Alternate_Phone_Number.isError = false;
        }
      }
      if (item === 'Beneficiary_Mobile_Number') {
        if (beneficiaryFormStateError.Beneficiary_Mobile_Number.value.length !== 0) {
          if (!/^\d+$/.test(beneficiaryFormStateError.Beneficiary_Mobile_Number.value)) {
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.isError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.message = "Phone number contains invalid characters. Enter a valid phone number.";
          }else if(beneficiaryFormStateError?.Beneficiary_Mobile_Number?.value?.length !== 10){
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.isError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.message = "Mobile number must contain 10 digits. Enter a valid mobile number.";
          }
        }
        else {
          beneficiaryFormStateError.Beneficiary_Mobile_Number.isError = false;
        }
      }
      if (item === 'pvtg' && temproryBenificiaryformdata?.pvtg) {
        if (!beneficiaryFormStateError.pvtg.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.pvtg.isError = true;
          beneficiaryFormStateError.pvtg.message = 'Is PVTG Classified cannot be empty. Choose either Yes or No.';
        }
        else {
          beneficiaryFormStateError.pvtg.isError = false;
        }
      }
      if (item === 'Spouse_Name') {
        if (!beneficiaryFormStateError.Spouse_Name?.value || beneficiaryFormStateError.Spouse_Name.value === 'Select') {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Spouse_Name.isError = true;
          beneficiaryFormStateError.Spouse_Name.message = 'Spouse name cannot be kept blank. Enter a valid spouse name.';
        }
        else if (!/^[a-zA-Z\s]+$/.test(beneficiaryFormStateError.Spouse_Name?.value)) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Spouse_Name.isError = true;
          beneficiaryFormStateError.Spouse_Name.message = 'Entered spouse name is invalid. Number & Special characters are not allowed.';
        }
        else if (beneficiaryFormStateError.Spouse_Name?.value.length > 100) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Spouse_Name.isError = true;
          beneficiaryFormStateError.Spouse_Name.message = 'Entered spouse name length is invalid. Max 100 characters are allowed.';
        } else {
          beneficiaryFormStateError.Spouse_Name.isError = false;
        }
      }
      if (item === 'Facility_type') {
        if (!beneficiaryFormStateError.Facility_type?.value || beneficiaryFormStateError.Facility_type.value === 'Select') {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Facility_type.isError = true;
          beneficiaryFormStateError.Facility_type.message = 'Select a valid facility type from the dropdown';
        } else {
          beneficiaryFormStateError.Facility_type.isError = false;
        }
      }
      if (item === 'Health_Provider_Name') {
        if (!beneficiaryFormStateError.Health_Provider_Name?.value || beneficiaryFormStateError.Health_Provider_Name.value === 'Select') {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Health_Provider_Name.isError = true;
          beneficiaryFormStateError.Health_Provider_Name.message = 'Select a valid Health Provider Name from the dropdown';
        } else {
          beneficiaryFormStateError.Health_Provider_Name.isError = false;
        }
      }
      if (item === 'Facility_Name') {
        if (!beneficiaryFormStateError.Facility_Name?.value || beneficiaryFormStateError.Facility_Name.value === 'Select') {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Facility_Name.isError = true;
          beneficiaryFormStateError.Facility_Name.message = 'Select a valid Facility Name from the dropdown';
        } else {
          beneficiaryFormStateError.Facility_Name.isError = false;
        }
      }
      if (item === 'other_religion' && temproryBenificiaryformdata.other_religion["#isDisabled"] === false) {
        if (temproryBenificiaryFormState.Religion.value !== 'Others') {
          beneficiaryFormStateError.other_religion.isError = false;
        }
        if (!beneficiaryFormStateError.other_religion?.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.other_religion.isError = true;
          beneficiaryFormStateError.other_religion.message = 'Enter the details other religion';
        }
        else {
          beneficiaryFormStateError.other_religion.isError = false;
        }
      }
      setTemproryBenificiaryFormState(beneficiaryFormStateError);
      isError[0] = isBeneficiaryFormError;
    })
    if (!isBeneficiaryFormError) {
      await getConsentLanguage();
    }
  }
  const handleCancel=()=>{
    setShowModal(false);
    setShowSpinner(false);
  }
  const getConsentLanguage = async () => {
    try {
      const type = "Beneficiary"
      const consent = "temporary_registration"      
      const response = await getUserConsentLanguage(type, consent);
      setConsentLanguageData(response);
      const res:any = response?.data[0]?.length 
      setCheckedState(new Array(res).fill(false));
      setShowModal(true);
    }catch(error:any){
        toast.error("Unable to fetch consent details. Please try again later.", {
        position: "top-center",
        });
        errorLogger(error?.response?.data||error?.response||error)
    }
  }
  const callSubmitApi=async()=>{
    const consentDetails = 
        consentLanguageData?.data[0]?.map((item :any)=> ({
            consent_template_id: item?.consent_template_id
        }))
      ;
      const consentIds=
        consentLanguageData?.data[0]?.map((item :any)=> (item?.consent_template_id
      ));
    const payload = {
        loginProcessId: loginId,
        regProcessId: regId,
        genderId: genderId,
        abhaId: null,
        consentTemplateId:consentIds?.length>0?consentIds:[],
        beneficiaryName: temproryBenificiaryFormState?.beneificery_name?.value,
        beneficiaryDob: BeneficiaryDate,
        primaryMob: temproryBenificiaryFormState?.Beneficiary_Mobile_Number?.value,
        abhaAddress: null,
        spouseName: temproryBenificiaryFormState?.Spouse_Name?.value,
        categoryId: temproryBenificiaryFormState?.caste?.id ? temproryBenificiaryFormState?.caste?.id : null,
        religionId: temproryBenificiaryFormState?.Religion?.id || null,
        otherReligion: temproryBenificiaryFormState?.other_religion?.value || null,
        alternateMob: temproryBenificiaryFormState?.Alternate_Phone_Number?.value,
        healthProviderId: temproryBenificiaryFormState?.Health_Provider_Name?.id ? [temproryBenificiaryFormState?.Health_Provider_Name?.id] : [],
        mobiliserId: temproryBenificiaryFormState?.Asha_Name?.id ? [temproryBenificiaryFormState?.Asha_Name?.id] : [],
        isPvtgClassified: temproryBenificiaryFormState.caste.value !== 'ST' ? null : temproryBenificiaryFormState.pvtg.value === 'Yes' ? true : false,
        enrollForSms: beneficiary?.enrollSMS,
        effectiveFromDt: null,
        wardId: temproryBenificiaryFormState?.Ward?.id || null,
        villageId: temproryBenificiaryFormState?.Village?.id || null,
        facilityId: temproryBenificiaryFormState.Facility_Name.id,
        isTempReg: true,
        imageData: null,
        url: null,
        filePath: null,
        description: 'Image for beneficiary',
        parentUserId: userId,
        parentUserTypeId: null,
        parentRoleId: null,
        consentTemplateDetails:consentDetails?.length>0?consentDetails:[],
        IsSharedMobileNumber:beneficiaryStore?.beneficiaryAlreadyInRCH,
        processChannel: 'web',
        regProcessType: "reg_through_healtprovider",
      }
      try {
        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
        const response = await postDataJSON<any>(`${endpoints.createBeneficiary}`, { data: encodedPayload });
        if (response.data && response.data.data[0].benf_id) {
          if (Files) {
            if(Files instanceof FormData) {
              Files.append("imageType", "beneficiary_profile");
              Files.append("objectId", response.data.data[0].benf_id);
             }
            const responses = await axios.post(`${endpoints.beneficiaryImageUpload}`,Files, Auth.loggedInWithMultipart())
          }
          toast.success("Beneficiary created Successfully", {
            position: "top-center"
          })
          navigate("/beneficiaries");
          dispatch(updateForm("file", null));
          dispatch(setBeneficiaryData([]));
          setShowWarning(false);
          dispatch(setBeneficiaryRedgOption(''));
          dispatch(setBeneficiaryAuthType(''));
          dispatch(setTxnIdForAbhaAddress(''));
        }
        else {
          toast.error("Something went wrong", {
            position: "top-center"
          })
        }
      }
      catch(error:any){
        setShowModal(false);
        setShowWarning(false);
        errorLogger(error?.response?.data||error?.response||error);
        toast.error("Something went wrong", {
          position: "top-center"
        })
      }
  }
  const submitConsentForm=async ()=>{
    try {
      setShowSpinner(true);
      const tempBenfCheckResponse = await getData<any>(`${endpoints.checkTempBenfExist(temproryBenificiaryFormState.beneificery_name.value,BeneficiaryDate,genderId)}`);
      if (!tempBenfCheckResponse.data[0].check_bnefiary_exist) {
        callSubmitApi();
        handleCancel();
      }
      else {
        handleCancel();
        setShowWarning(true);
      }
    }catch (error: any) {
      handleCancel();
      errorLogger(error?.response?.data||error?.response||error)
    }

   }
  const handleSelectAll = (checked: boolean) => {
    setCheckedState(new Array(checkedState?.length).fill(checked));

  };
  const handleCheckboxChange = (index: number, checked: boolean) => {
      const updatedCheckedState = [...checkedState];
      updatedCheckedState[index] = checked;
      setCheckedState(updatedCheckedState);
    };
  return (
    <div className="temp_benf_wrapper">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: 'Service Provider', label: 'Service Provider' },
              { value: 'Beneficiary Registration', label: 'Beneficiary Registration' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <CommonHamburgar>
              <LeftNavBar
                navItems={['User Details']}
                currentTab={'User Details'}
                handleNavClick={() => { }}
              />
            </CommonHamburgar>
            <Link to={'/beneficiaries'}>
              <Button
                onClick={() => { }}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
            </Link>
            {
              imageUrl ? <div
                className="profile-picture"
                style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }}
              ></div> : <img
                className="profile-picture"
                src={profilePic}
                alt='Profile Image'
              />
            }
            <div style={{ display: "flex", flexDirection: "column", fontSize: "13px" }}>
              <div className="name">{`Beneficiary`}</div>
              <div style={{ display: "flex", flexDirection: "row", gap: "5px", fontSize: "13px" }}>
                <div>
                  {beneficiaryStore.beneficiaryGender === 'Female' ? <WomanIcon /> : <ManIcon />}
                </div>
              </div>
            </div>
            <div>
              <div>
                <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                  <Button
                    onClick={() => handleUploadClick('local')}
                    disabled={false}
                    id="add-profile-picture"
                    buttonName={imageUrl !== '' ? 'Change Profile Picture' : "+ Add Profile Picture"}
                    colorType={'primary'}
                    iconPosition={'left'}
                  />
                  <span className='tooltip-profile-pic'><CustomTooltip text={'File size must be less than or equal to 1MB and Only JPG, JPEG and PNG images are allowed'} /></span>
                </div>

                {imageError.length > 0 && <InfoBar
                  variant="danger"
                  message={imageError}
                  className="input_field_class profile-pic-error"
                />}
              </div>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={handleFileChange}
                className="profile-picture-hidden-input"
                ref={inputRef}
              />
            </div>
            {imageUrl !== '' && <Button
              onClick={() => {
                setImageUrl('')
                dispatch(updateForm("file", null));
              }}
              disabled={false}
              id="delete-profile-picture"
              buttonName={'Delete'}
              colorType={'save'}
            />}

          </div>
        </div>
        <div className="content">
          <LeftNavBar
            navItems={['User Details']}
            currentTab={'User Details'}
            handleNavClick={() => { }}
          />
          <div className="tab-content">
            <div className="temp_beneficiary_create">
              <div className="create_temp_beneficiary">
                <BadgesComponent
                  className="over-badge"
                  badgeName="User Details"
                  variant="primary-1"
                  badgeType="case5"
                />
                <div className="overview-details-update">
                  <div className="create_temp_beneficiary_page">
                    <form className="temp_create_container_page">
                      <CommonFormFields
                        formData={temproryBenificiaryformdata}
                        formState={temproryBenificiaryFormState}
                        handleFormChange={handleFormChange}
                      />
                    </form>
                  </div>
                </div>
                {<div className="cancel-edit">
                  {<Button
                    onClick={() => {
                      navigate("/beneficiaries");
                    }}
                    disabled={false}
                    id="cancel"
                    buttonName={'Cancel'}
                    colorType={'save'}
                    icon={''}
                    iconPosition={'right'}

                  />}
                  <Button
                    onClick={handleSubmit}
                    disabled={false}
                    id={''}
                    buttonName={'Submit'}
                    colorType={'primary'}
                    iconPosition={'right'}
                  />
                </div>}
              </div>

            </div>
          </div>
        </div>
        <>
        {showModal &&<div className="beneficiary_temporary_registration_modal_main">
                <Modal
                    show={showModal}
                    onHide={() => handleCancel()}
                    dialogClassName={'beneficiary_temporary_registration_modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Body >
                      <div className="temporary_consent_form_enlarge">
                        <h1 className="aadhar_headings">Consent Process</h1>
                        <div className="consent_form_for_temporary">
                          I hereby declare that:
                          {/* Select All Checkbox */}
                          <CheckboxComponent
                            isChecked={isAllChecked}
                            onCheckboxChange={handleSelectAll}
                            disabled={false}
                            className="consent-select-all"
                            checkBoxName="Select All"
                          />
                          {consentLanguageData?.data[0]?.map((item: any, index: any) => (
                            <CheckboxComponent
                              key={index}
                              isChecked={checkedState?.[index]}
                              onCheckboxChange={(checked) =>
                                handleCheckboxChange(index, checked)
                              }
                              disabled={false}
                              className={`consent-checkbox-item-${index}`}
                              checkBoxName={
                                item?.consent_template_content.includes('{#var1#}')
                                  ? item?.consent_template_content.replace(
                                    '{#var1#}',
                                    `${userDetail.first_name || ''} ${userDetail.last_name || ''}`
                                  ):
                                  item?.consent_template_content?.includes('{#name#}')?
                                  item?.consent_template_content.replace(
                                    '{#name#}',
                                    `${temproryBenificiaryFormState.beneificery_name.value.trim() || ''}`
                                  )
                                : item?.consent_template_content
                              }
                            />
                          ))}
                        </div>
                       
                        <div className="aadhar-submit">
                          {showSpinner && <span style={{ marginBottom: '20px' }}><Spinner /></span>}
                          <Button
                            onClick={submitConsentForm}
                            disabled={(isAllChecked ? false : true) || showSpinner}
                            id="aadhar-beneficiary-submit"
                            buttonName={'Submit'}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={''}
                          />
                        </div>
                      </div>
                    </Modal.Body>
                </Modal>
            </div>}
        </>
      </main>
      {showWarning && <CommonModal
            show={showWarning}
            handleClose={()=>{}}
            conditionalClass="modal_component dynamic_form_field"
            showCustomHeader={true}
            title=""
            size="md"
            footer={
         <div className='hrp-warning-modal-footer'>
                <ButtonModal
                  onClick={()=>{
                    callSubmitApi();
                    setShowWarning(false);
                  }}
                  id="cancel"
                  buttonName={buttonNames.yes}
                  colorType={'secondary'}
                />
                <ButtonModal
                  onClick={()=>{setShowWarning(false)}}
                  id="cancel"
                  buttonName={buttonNames.no}
                  colorType={'secondary'}
                /> </div>
             
            }
          >
            <div className='hrp-warning-modal'>
              <div className='icon-class'><RedInfoIcon /></div>
              <div className='warning-text'>{benef_const.tempBenfWarningMessage}</div>
            </div>
          </CommonModal>}
    </div>

  );
};

export default TemporaryBenificiary;
